import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// ==================== ICONS ====================
const UserIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
  </svg>
);

const ComputerDesktopIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" />
  </svg>
);

const PencilIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
  </svg>
);

const BeakerIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
  </svg>
);

const TrophyIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0" />
  </svg>
);

const BookOpenIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
  </svg>
);

const PaintBrushIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42" />
  </svg>
);

const ChevronRightIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
  </svg>
);

// ==================== REUSABLE COMPONENTS ====================

const Container = ({ className = "", children }) => (
  <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>
);

const SectionHeader = ({ eyebrow, title, description, align = "left" }) => (
  <div className={align === "center" ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}>
    {eyebrow && (
      <div className={align === "center" ? "flex justify-center" : ""}>
        <span className="inline-flex items-center gap-2 text-school-goldDark font-semibold tracking-[0.18em] uppercase text-xs">
          <span className="h-1.5 w-1.5 rounded-full bg-school-gold" aria-hidden="true" />
          {eyebrow}
        </span>
      </div>
    )}
    <h2 className="mt-3 text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-school-blue leading-[1.08] tracking-tight">
      {title}
    </h2>
    {description && (
      <p className={`mt-4 text-base md:text-lg text-gray-600 leading-7 ${align === "center" ? "mx-auto" : ""}`}>
        {description}
      </p>
    )}
  </div>
);

const ProgramCard = ({ icon, title, description, href }) => (
  <a
    href={href}
    className="group block p-8 bg-white rounded-3xl border border-gray-100 shadow-soft hover:shadow-md transition-all duration-300 hover:-translate-y-0.5"
  >
    <div className="flex items-start justify-between gap-4 mb-6">
      <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-school-blue/8 text-school-blue group-hover:bg-school-blue group-hover:text-white transition-colors duration-300 shadow-sm">
        {icon}
      </div>
      <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-600 group-hover:bg-school-blue group-hover:text-white transition-colors duration-300">
        <ChevronRightIcon />
      </div>
    </div>
    <h3 className="text-xl md:text-2xl font-heading font-bold text-gray-900 group-hover:text-school-gold transition-colors mb-3 tracking-tight">
      {title}
    </h3>
    <p className="text-sm md:text-base text-gray-600 leading-7">
      {description}
    </p>
  </a>
);

const StaffCard = ({ name, role, image }) => (
  <div className="group flex flex-col items-center p-8 bg-white rounded-3xl border border-gray-100 shadow-soft hover:shadow-md transition-all duration-300 hover:-translate-y-0.5">
    <div className="relative mb-6">
      <div className="w-24 h-24 rounded-full overflow-hidden bg-gray-100 border-4 border-school-gold/20 shadow-sm">
        {image ? (
          <img src={image} alt={name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-school-blue/8 text-school-blue">
            <UserIcon className="w-12 h-12" />
          </div>
        )}
      </div>
    </div>
    <h3 className="text-lg md:text-xl font-heading font-bold text-gray-900 mb-2 tracking-tight text-center group-hover:text-school-gold transition-colors">
      {name}
    </h3>
    <p className="text-sm md:text-base text-school-goldDark font-medium text-center">{role}</p>
  </div>
);

// ==================== MAIN COMPONENT ====================

const Enrichment = () => {
  const programs = [
    {
      icon: <ComputerDesktopIcon />,
      title: "Computer Science",
      description: "Students explore coding, computational thinking, and technology through hands-on projects and activities.",
      href: "/computer-science"
    },
    {
      icon: <PencilIcon />,
      title: "Creative Writing",
      description: "Developing writing skills and creative expression through various literary forms and genres.",
      href: "/creative-writing"
    },
    {
      icon: <BeakerIcon />,
      title: "Hydroponics",
      description: "Hands-on learning about plant science, sustainability, and modern agricultural techniques.",
      href: "/hydroponics"
    },
    {
      icon: <TrophyIcon />,
      title: "Physical Education",
      description: "Promoting fitness, teamwork, and healthy lifestyles through physical activity and sports.",
      href: "/physical-education"
    },
    {
      icon: <BookOpenIcon />,
      title: "Social Studies",
      description: "Exploring history, geography, culture, and civic engagement to understand our world.",
      href: "/social-studies"
    },
    {
      icon: <PaintBrushIcon />,
      title: "The Arts",
      description: "Fostering creativity and self-expression through visual arts, music, and performance.",
      href: "/the-arts"
    }
  ];

  const staffMembers = [
    { name: "Melisa Berkowitz", role: "Creative Writing", image: null },
    { name: "Sandro Brevetti", role: "Physical Education", image: null },
    { name: "Jennifer Coffey", role: "Art", image: null },
    { name: "Marcus Depompeis", role: "Music", image: null },
    { name: "Kevin Flynn", role: "Physical Education", image: null },
    { name: "Tennyson Hurd", role: "Social Studies", image: null },
    { name: "Amanda Montero De La Cruz", role: "Hydroponics", image: null },
    { name: "Robert Moore", role: "Computer Science", image: null },
    { name: "Emmanuel Tavarez", role: "Physical Education", image: null }
  ];

  return (
    <div className="min-h-screen font-sans text-gray-600 antialiased selection:bg-school-gold/30 selection:text-school-blue" style={{ backgroundColor: '#F5EFE0' }}>
      <Navbar />

      <main id="main-content">

        {/* ==================== HERO SECTION ==================== */}
        <section className="relative min-h-[50vh] md:min-h-[60vh] flex items-center overflow-hidden bg-[#0F2240]">
          <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 70% 50% at 50% 100%, rgba(197,145,50,0.1) 0%, transparent 70%)' }} />

          <Container className="relative z-10 pt-32 pb-16 md:pt-40 md:pb-20">
            <div className="max-w-4xl bg-[#0F2240]">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white/90 text-xs sm:text-sm font-semibold mb-7">
                <span className="w-2 h-2 rounded-full bg-school-gold" aria-hidden="true" />
                Student Services
              </div>

              <h1 className="text-4xl sm:text-5xl md:text-6xl font-heading font-bold text-white tracking-tight leading-[1.05]">
                Enrichment Programs
              </h1>

              <p className="mt-6 text-lg md:text-xl text-gray-200 leading-relaxed max-w-3xl">
                Expanding learning opportunities beyond the classroom
              </p>
            </div>
          </Container>
        </section>

        {/* ==================== INTRODUCTION ==================== */}
        <section className="py-20 md:py-28 bg-[#F5EFE0]">
          <Container>
            <SectionHeader
              align="center"
              eyebrow="Beyond Academics"
              title="Enriching Student Experience"
              description="Our enrichment programs provide students with diverse opportunities to explore their interests, develop new skills, and discover their passions"
            />
          </Container>
        </section>

        {/* ==================== PROGRAMS GRID ==================== */}
        <section className="py-20 md:py-28 bg-[#EDE5D0]">
          <Container>
            <SectionHeader
              align="center"
              eyebrow="Our Programs"
              title="Explore Our Offerings"
              description="Explore any program to learn more about what we offer"
            />

            <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
              {programs.map((program, index) => (
                <ProgramCard key={index} {...program} />
              ))}
            </div>
          </Container>
        </section>

        {/* ==================== STAFF MEMBERS ==================== */}
        <section className="py-20 md:py-28 bg-white">
          <Container>
            <SectionHeader
              align="center"
              eyebrow="Our Team"
              title="Meet Our Staff"
              description="The teachers who lead our enrichment programs"
            />

            <figure className="mt-14 mx-auto max-w-3xl">
              <img
                src="/assets/images/staff-teams/enrichment.jpg"
                width={1200}
                height={617}
                alt="Members of the Enrichment team gathered in front of a Hispanic Heritage Month bulletin board."
                loading="lazy"
                className="w-full h-auto rounded-3xl shadow-xl shadow-school-blue/10"
              />
            </figure>

            <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8">
              {staffMembers.map((staff) => (
                <StaffCard key={staff.name} {...staff} />
              ))}
            </div>
          </Container>
        </section>

        {/* ==================== CTA SECTION ==================== */}
        <section className="relative py-24 md:py-32 bg-school-gold overflow-hidden">
          <div className="absolute -right-20 -top-20 w-96 h-96 bg-school-blue/8 rounded-full blur-3xl pointer-events-none" />

          <Container className="relative text-center">
            <h2 className="text-4xl md:text-6xl font-heading font-bold text-school-blue mb-6">
              Join Our Programs
            </h2>
            <p className="text-xl text-school-blue max-w-2xl mx-auto mb-10 font-light">
              Discover new interests and develop your talents through our enrichment programs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/coming-soon"
                className="px-8 py-4 rounded-full bg-school-blue text-white font-bold hover:bg-[#0F2240] transition-colors shadow-soft"
              >
                Contact Us
              </a>
              <a
                href="/"
                className="px-8 py-4 rounded-full bg-white/30 text-school-blue border-2 border-school-blue/20 font-medium hover:bg-white/50 transition-colors"
              >
                Back to Home
              </a>
            </div>
          </Container>
        </section>

        <Footer />
      </main>
    </div>
  );
};

export default Enrichment;
